import { useQuery } from 'react-query';
import { apiCpService } from '@services/apiCpService.ts';
import { ChargePointMapper } from '@services/mappers/charge-point.mapper.ts';
import { DATA_REFETCHING_INTERVAL_MS } from '@shared/constants/api.constants.tsx';
import { useAppStore } from '@stores/app.store.ts';

export const FindChargePointDetailsQueryKey = 'find-charge-point-details';

export const useFindChargePointDetailsQuery = (cpid?: string) => {
  const isLiveDataEnabled = useAppStore(state => state.isLiveDataEnabled);

  return useQuery(
    [FindChargePointDetailsQueryKey, cpid],
    async () => {
      const { data } = await apiCpService.getChargepointCpClientChargepointCpidGet(cpid!);

      return ChargePointMapper.toChargePoint(data);
    },
    {
      enabled: cpid != undefined,
      refetchInterval: isLiveDataEnabled ? DATA_REFETCHING_INTERVAL_MS : undefined,
    },
  );
};
